module.exports = __webpack_public_path__ + "img/SAS_RoughGreenNomadShield.3c2f5605.png";